module.exports = __webpack_public_path__ + "static/img/8.520d054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/8.png
// module id = 27c7
// module chunks = 0